import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { List, ListItem, ListItemText, ListItemAvatar, ListItemButton, Avatar, Chip, Box, Typography, Button, TextField,InputAdornment } from "@mui/material";
import { Image, InsertDriveFile, Description, Search } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";

function TransferHistory({history, onBelegClicked, hideSearchbar=false}) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        const searchQueryParam = searchParams.get("query")
        if (searchQueryParam) {
            setSearchQuery(searchQueryParam);
        }
      },[searchParams]);

    let filteredKeys = [];
    if (history && history.allKeysByDate && history.allKeysByDate.length>0) {
        if (searchQuery) {
            filteredKeys = history.allKeysByDate.filter(key => history.byKey[key].betreff.toLowerCase().includes(searchQuery.toLowerCase()));
        } else {
            filteredKeys = [...history.allKeysByDate];
        }
    }

    const renderIconByType = (filetype) => {
        switch (filetype) {
            case ".svg":
            case ".png":
            case ".jpg":
            case ".jpeg":
            case ".tif":
            case ".tiff":
            case ".bmp":
            case ".gif":
            case ".gif":                
            case ".webp": 
            case ".heif":
            case ".heic":
                return <Avatar><Image /></Avatar>
            case ".pdf":
                return <Avatar><Description /></Avatar>
            default:
                return <Avatar><InsertDriveFile /></Avatar>
        }
    }

    const renderListItem = (beleg) => {
        return (
            <>
                <ListItemAvatar>
                    {renderIconByType(beleg.dateiart)}
                </ListItemAvatar>
                <ListItemText 
                primary={beleg.betreff ? beleg.betreff : beleg.dateiname}
                secondary={beleg.hochgeladenUmText.substring(0,10)} />
                    <Chip label={beleg.dateiart} />
            </>
        )
    }

    const handleAlleAnzeigenChange = () => navigate("/GESEND");

    return (
        <>
            <Box p={1}>
                <Typography align="left" variant="h5">
                    {t("Gesendete Belege")}
                </Typography>
            </Box>
            {!hideSearchbar && (
                <Box pl={2} pr={2} pt={1} pb={1}>
                    <TextField
                    variant="outlined"
                    label={t("Suche")}
                    value={searchQuery}
                    onChange={(event) => {
                        setSearchQuery(event.target.value);
                    }}
                    fullWidth
                    InputLabelProps={{
                        shrink: true,
                    }}
                    InputProps={{
                        startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                        ),
                    }}
                    />
                </Box>
            )}
        <List>
            {filteredKeys && filteredKeys.length>0 && filteredKeys.map(id => (
                <ListItem key={id} disablePadding={!!onBelegClicked}>
                    {onBelegClicked && (
                        <ListItemButton onClick={()=>onBelegClicked(history.byKey[id])}>
                            {renderListItem(history.byKey[id])}
                        </ListItemButton>
                    )}
                    {!onBelegClicked && renderListItem(history.byKey[id])}
                </ListItem>
             ))}
             {(!filteredKeys || filteredKeys.length==0) && !searchQuery && <Box p={1}><Typography align="left" variant="body2">{t("Es wurden noch keine Belege hochgeladen.")}</Typography></Box>}
             {(!filteredKeys || filteredKeys.length==0) && searchQuery && <Box p={1}><Typography align="left" variant="body2">{t("Es wurden keine Belege für den Suchbegriff gefunden.")}</Typography></Box>}
        </List>
        {history && history.weitereVorhanden && history.historieZugriff && (
            <Button color="primary" onClick={handleAlleAnzeigenChange}>
                {t("Alle anzeigen")}
          </Button>
        )}  
        </>
    );
}

export default TransferHistory;